import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import * as Model from './sms-call';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SmsCallService {

  // Injections
  private http = inject(HttpClient);

  // Get Twilio Subaccount Settings
  getTwilioSubaccountSettings(): Observable<Model.SubAccountDetails> {
    return this.http.get<Model.SubAccountDetails>(`/settings/twilio/subaccount`);
  }

  // Toggle Twilio Status
  toggleTwilioStatus(status: boolean): Observable<void> {
    return this.http.put<void>(`/settings/twilio/toggleStatus`, { status: status });
  }

  // Create Business Registration
  createBusinessRegistration(data: Model.BusinessInformation): Observable<Model.BusinessInformation> {
    return this.http.post<Model.BusinessInformation>(`/settings/twilio/businessRegistration`, data);
  }
 
  // Update Business Registration
  updateBusinessRegistration(data: Model.BusinessInformation): Observable<Model.BusinessInformation> {
    return this.http.put<Model.BusinessInformation>(`/settings/twilio/businessRegistration`, data);
  }

  // Create Authorized Representative
  createAuthorizedRepresentative(data: Model.AuthorizedRepresentative): Observable<Model.AuthorizedRepresentative> {
    return this.http.post<Model.AuthorizedRepresentative>(`/settings/twilio/authorizedRepresentative`, data);
  }
 
  // Update Authorized Representative
  updateAuthorizedRepresentative(data: Model.AuthorizedRepresentative): Observable<Model.AuthorizedRepresentative> {
    return this.http.put<Model.AuthorizedRepresentative>(`/settings/twilio/authorizedRepresentative`, data);
  }

  // Create Business Address
  createBusinessAddress(data: Model.BusinessAddress): Observable<Model.BusinessAddress> {
    return this.http.post<Model.BusinessAddress>(`/settings/twilio/businessAddress`, data);
  }
 
  // Update Business Address
  updateBusinessAddress(data: Model.BusinessAddress): Observable<Model.BusinessAddress> {
    return this.http.put<Model.BusinessAddress>(`/settings/twilio/businessAddress`, data);
  }

  // Evaluate And Submit
  evaluateAndSubmit(): Observable<{ isCompliant: boolean }> {
    return this.http.get<{ isCompliant: boolean }>(`/settings/twilio/evaluateAndSubmit`);
  }

  // Get Organization Numbers
  getOrgNumbers(): Observable<any[]> {
    return this.http.get<any[]>(`/settings/twilio/numbers`);
  }

  // Toggle Messaging Service
  toggleMessagingService(status: "ACTIVE" | "INACTIVE"): Observable<void> {
    return this.http.put<void>(`/settings/twilio/toggleMessagingService`, { status: status });
  }


  settingsUrl = `/settings/smscall`;
  callUrl = `/call`;

  private handleError(error: HttpErrorResponse) {
    return throwError('Something bad happened; please try again later.');
  }

  

  // createServiceAndCampaign(serviceAndCampaign: any) {
  //   return this.http.post(
  //     `${this.settingsUrl}/createserviceandcampaign`,
  //     serviceAndCampaign
  //   );
  // }

  // changeAccStatus(status: boolean): Observable<any> {
  //   return this.http
  //     .post<any>(`${this.settingsUrl}/changestatus?status=${status}`, null)
  //     .pipe(
  //       map((res: any) => <any>res),
  //       catchError(this.handleError)
  //     );
  // }

  // getSmsCallSettings(): Observable<any> {
  //   return this.http.get<any>(`${this.settingsUrl}`).pipe(
  //     map((res: any) => <any>res),
  //     catchError(this.handleError)
  //   );
  // }

  // postBusinessInfo(data: any): Observable<any> {
  //   return this.http.post<any>(`${this.settingsUrl}/businessinfo`, data).pipe(
  //     map((res: any) => <any>res),
  //     catchError(this.handleError)
  //   );
  // }

  // postAuthorizedRep(data: any): Observable<any> {
  //   return this.http.post<any>(`${this.settingsUrl}/authorizedrep`, data).pipe(
  //     map((res: any) => <any>res),
  //     catchError(this.handleError)
  //   );
  // }

  // postBusinessAddress(data: any): Observable<any> {
  //   return this.http
  //     .post<any>(`${this.settingsUrl}/businessaddress`, data)
  //     .pipe(
  //       map((res: any) => <any>res),
  //       catchError(this.handleError)
  //     );
  // }

  // submitForReview(): Observable<any> {
  //   return this.http.post<any>(`${this.settingsUrl}/profilereview`, null).pipe(
  //     map((res: any) => <any>res),
  //     catchError(this.handleError)
  //   );
  // }

  callAnumber(to: string): Observable<any> {
    const defaultNumber = JSON.parse(
      localStorage.getItem('login')
    )?.defaultNumber;

    return this.http
      .post<any>(`${this.callUrl}/callanumber`, {
        to,
        from: defaultNumber,
      })
      .pipe(
        map((res: any) => <any>res),
        catchError(this.handleError)
      );
  }

  exportMessageHistoryAndLogs(data) {
    return this.http
      .post(`${this.settingsUrl}/messagehistory`, data, {
        responseType: 'text',
      })
      .subscribe({
        next: (csvData: string) => {
          return this.downloadFile(csvData, data, 'Message_History_and_Logs');
        },
        error: (error) => {
          console.error(error);
        },
      });
  }

  private downloadFile(data: string, body: any, title: string) {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    const date = body.dateSent ? new Date(body.dateSent) : new Date();
    a.href = url;
    a.download = `${title}_${date.getMonth() + 1
      }-${date.getDate()}-${date.getFullYear()}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  callRecordingEnableDisable(status: boolean): Observable<any> {
    return this.http
      .put<any>(`${this.settingsUrl}/callrecord/${status}`, null)
      .pipe(
        map((res: any) => <any>res),
        catchError(this.handleError)
      );
  }

  getCurrentUsage(startDate: string, endDate: string): Observable<any> {
    return this.http.get<any>(`${this.settingsUrl}/invoice/${startDate}/${endDate}`).pipe(
      map((res: any) => <any>res),
      catchError(this.handleError)
    );
  }
}
